import {
  MarkAsPaidInput,
  PaginatedTicketBillableItems
} from 'types/BillingTypes';
import useHttp from '../helpers/HttpMethods';

const http = useHttp();

class BillingService {
  /**
   * Lista os itens faturáveis para a tela de faturamento paginados.
   * @param {string} filter - Filtros em string.
   * @returns {Promise<PaginatedTicketBillableItems | Response>} - Itens faturáveis em formato paginado.
   */
  static async listBillableItems(
    filter: string
  ): Promise<PaginatedTicketBillableItems | Response> {
    return await http.get(`/billing/billable-items?${filter}`);
  }

  /**
   * Marca múltiplos itens como pagos.
   * @param {MarkAsPaidInput} body - Array de IDs dos itens a serem marcados como pagos.
   * @returns {Promise<Response>} - Retorno padrão de uma request.
   */
  static async markAsPaid(body: MarkAsPaidInput): Promise<Response> {
    return await http.put(body, '/billing/billable-items/mark-as-paid');
  }

  /**
   * Lista grupos de itens faturáveis agrupados por cliente.
   * @param {string} filter - Filtros em string (page, size, billingStatus).
   * @returns {Promise<any>} - Grupos paginados por cliente.
   */
  static async getGroupedByCustomer(filter: string): Promise<any> {
    return await http.get(`/billing/grouped-by-customer?${filter}`);
  }

  /**
   * Lista grupos de itens faturáveis agrupados por ticket.
   * @param {string} filter - Filtros em string (page, size, billingStatus).
   * @returns {Promise<any>} - Grupos paginados por ticket.
   */
  static async getGroupedByTicket(filter: string): Promise<any> {
    return await http.get(`/billing/grouped-by-ticket?${filter}`);
  }

  /**
   * Lista itens faturáveis de um cliente específico.
   * @param {number} customerId - ID do cliente.
   * @param {string} filter - Filtros em string (page, size, billingStatus).
   * @returns {Promise<PaginatedTicketBillableItems | Response>} - Itens faturáveis paginados.
   */
  static async getBillableItemsByCustomer(
    customerId: number,
    filter: string
  ): Promise<PaginatedTicketBillableItems | Response> {
    return await http.get(`/customers/${customerId}/billable-items?${filter}`);
  }

  /**
   * Lista itens faturáveis de um ticket específico.
   * @param {number} ticketId - ID do ticket.
   * @param {string} filter - Filtros em string (page, size, billingStatus).
   * @returns {Promise<PaginatedTicketBillableItems | Response>} - Itens faturáveis paginados.
   */
  static async getBillableItemsByTicket(
    ticketId: number,
    filter: string
  ): Promise<PaginatedTicketBillableItems | Response> {
    return await http.get(`/tickets/${ticketId}/billable-items/search?${filter}`);
  }
}

export default BillingService;
